export default __webpack_public_path__ + "static/media/dr-ukachi-amadi.e191f824.png";